<template>
  <div class="index-container">
    <div class="main">
      <h1 class="title">{{detail.title}}</h1>
      <p class="time">{{timeChange(detail.publicTime)}}</p>
      <div class="content" v-html="detail.content">
    </div>
    </div>
  </div>
</template>

<script>
import { newsDetail } from '../../request/api.js'
import { timeChange } from '../../assets/js/globle.js'

export default {
  components: {
  },
  data () {
    return {
      timeChange: timeChange,
      detail: {

      }
    }
  },
  created () {
    if (this.$route.params.uuid) {
      let uuid = this.$route.params.uuid
      this.init(uuid)
    }
  },
  mounted () {
  },
  methods: {
    init (uuid) {
      newsDetail({uuid: uuid}).then((res) => {
        this.detail = res.data
        document.title = res.data.title + '女娲NVWA'
        document.querySelector('meta[name="keyword"]').setAttribute('content', res.data.title + '女娲NVWA')

        let description = res.data.content
        description = description.replace(/(\n)/g, '')
        description = description.replace(/(\t)/g, '')
        description = description.replace(/(\r)/g, '')
        description = description.replace(/<\/?[^>]*>/g, '')
        description = description.replace(/\s*/g, '')
        if (description.length > 50) {
          description = description.substring(0, 50)
        }
        document.querySelector('meta[name="description"]').setAttribute('content', description)
        // let head = document.getElementsByTagName('head')
        // let meta = document.getElementsByTagName('meta')
        // console.log(meta)
        // // meta.content = res.data.title
        // // meta.keywords = res.data.title
        // // head[0].appendChild(meta)

        // document.description = res.data.title + '女娲NVWA'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .index-container {
    width: 100%;
    min-height: 403px;
    min-width: 1200px;
    background-color: white;
    @media screen and(max-width:768px) {
      width: 100%;
      min-width: 100%;
      padding: 0 20px 20px 20px;
    }

    .main{
      width: 100%;
      max-width: 1200px;
      background-color: white;
      margin: 0 auto;
      overflow: auto;
      .title{
        font-size: 36px;
        font-weight: 600;
        color: #222222;
        line-height: 50px;
        margin-top:106px;
        @media screen and(max-width:768px){
          margin-top:23px;
        }
      }
      .time{
        font-size: 14px;
        font-weight: 400;
        color: #676767;
        line-height: 34px;
        margin:24px 0 40px 0;
        @media screen and(max-width:768px){
          margin:7px 0 9px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/news/info.vue